export default "__VITE_ASSET__DEoi3p10__"